import { sqItemsApi } from '@seeqdev/api/endpoint/ItemsApi';
import type { AssetLeafChildName } from '@/itemFinder/itemFinder.constants';
import type { ColumnDefinitionInputV1 } from '@seeqdev/api/model/ColumnDefinitionInputV1';
import type { StoredTableSearchV1 } from '@seeqdev/api/model/StoredTableSearchV1';

export const loadStoredTableColumnDefinitions = async (
  storedTableSearches: StoredTableSearchV1[],
  tableDefinitionId?: string,
): Promise<ColumnDefinitionInputV1[]> => {
  if (storedTableSearches.length === 0) {
    return [];
  }

  const { data } = await sqItemsApi.buildStoredTableColumnDefinitions({
    storedTableSearches,
    tableDefinitionId,
  });
  return data.columnDefinitions ?? [];
};

/**
 * Fetch a page of the selected asset's leaf-descendant names (grouped, with counts) for the Tree Builder "asset leaf
 * children" search. Pagination is over the distinct names; `totalResults` is the number of distinct names.
 */
export const loadAssetChildNameCounts = async (
  asset: string,
  types: string[],
  filter: string,
  offset: number,
  limit: number,
): Promise<{ items: AssetLeafChildName[]; totalResults: number }> => {
  const { data } = await sqItemsApi.getAssetChildrenByName({
    asset,
    types,
    filter: filter || undefined,
    offset,
    limit,
  });
  return {
    items: (data.items ?? []).map((item) => ({ name: item.name, count: item.count, types: item.types ?? [] })),
    totalResults: data.totalResults ?? 0,
  };
};
